import * as ACTION from '../../Redux.constants';
import {viewThreeDrop} from './ViewThreeDrop';
import {viewThreeHint} from './ViewThreeHint';
import {viewThreeRemoveStep} from './ViewThreeRemoveStep';
import {viewThreeSetStep} from './ViewThreeSetStep';
import {viewThreeComplete} from './ViewThreeComplete';

export function ViewThreeReducer(state, action) {
  switch (action.type) {
    case ACTION.VIEW_THREE_DROP:
      return viewThreeDrop(state, action.payload);
    case ACTION.VIEW_THREE_SET_STEP:
      return viewThreeSetStep(state, action.payload);
    case ACTION.VIEW_THREE_REMOVE_STEP:
      return viewThreeRemoveStep(state, action.payload);
    case ACTION.VIEW_THREE_HINT:
      return viewThreeHint(state, action.payload);
    case ACTION.VIEW_THREE_COMPLETE:
      return viewThreeComplete(state, action.payload);
    default:
      return state;
  }
}
